import { FC } from 'react';
import styled from 'styled-components';
import { ItemLayout } from '@clds/item';
import { DropdownMenuItemContentProps } from './DropdownMenuItem.types';

export const DropdownMenuItemContent: FC<React.PropsWithChildren<DropdownMenuItemContentProps>> = ({
  leftSlot,
  rightSlot,
  secondaryContent,
  children,
}) => (
  <StyledItemLayout leftSlot={leftSlot} rightSlot={rightSlot} secondaryContent={secondaryContent && <StyledEllipsis children={secondaryContent} />}>
    <StyledEllipsis children={children} />
  </StyledItemLayout>
);

const StyledEllipsis = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledItemLayout = styled(ItemLayout)`
  :hover {
    background: ${(props) => props.theme.palette.primary}0F;
  }}
`;
